import React from 'react';

const testIds = {
    PAUSE_ICON: 'PAUSE_ICON'
};

const PauseIcon = (props: any) => (
    <svg
        data-test-id={testIds.PAUSE_ICON}
        {...props}
        width="20"
        height="16.5"
        viewBox="0 0 20 16.5"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.625 0C0.279825 0 0 0.279825 0 0.625V16.875C0 17.2202 0.279825 17.5 0.625 17.5H6.875C7.22018 17.5 7.5 17.2202 7.5 16.875V0.625C7.5 0.279825 7.22018 0 6.875 0H0.625ZM11.25 0C10.9048 0 10.625 0.279825 10.625 0.625V16.875C10.625 17.2202 10.9048 17.5 11.25 17.5H17.5C17.8452 17.5 18.125 17.2202 18.125 16.875V0.625C18.125 0.279825 17.8452 0 17.5 0H11.25Z"
            fill="#F9FAFA"
        ></path>
    </svg>
);

export {PauseIcon};
